import { ajax } from 'rxjs/ajax';
import { catchError } from 'rxjs/operators';
import { throwError, EMPTY } from 'rxjs';
import history from './history';
import { toast } from 'react-toastify';
import { default as nodeFetch } from 'node-fetch';

export default function request(params) {
    let { headers, url, params: urlParams, inheritError = false, ...others } = params;
    url = process.env['REACT_APP_API'] + (url ? url : '/');

    if (urlParams && Object.prototype.toString.call(urlParams) === '[object Object]') {
        url += '?' + new URLSearchParams(urlParams).toString();
    }

    const isRest = /restaurante/i.test(history.location.pathname);

    //TODO: herdar autocomplete .d.ts
    return ajax({
        ...others,
        url,
        headers: {
            Authorization: `JWT ${localStorage.getItem(isRest ? 'JWTR' : 'JWTANF')}`,
            ...headers,
        },
    }).pipe(
        catchError((error) => {
            //TODO: detectar problemas de net, botão copiar ID
            const err = !error.response ? { ...error, response: {} } : error;

            if (!inheritError) {
                toast.error(
                    err.response.message
                        ? err.response.message
                        : `Ops, houve um erro inesperado.${
                              err.response.id ? ' ID: ' + err.response.id : ''
                          }`,
                    { autoClose: err.response.isHandled ? 4000 : false },
                );
                if (process.env['NODE_ENV'] === 'development') {
                    console.error(err);
                }
            }

            if (err.status) {
                if (err.status === 401 && !/sessao-expirada/.test(window.location.href) && !isRest)
                    history.push('/sessao-expirada');
                else if (
                    err.status === 401 &&
                    isRest &&
                    history.location.pathname !== '/restaurante'
                )
                    history.replace('/restaurante');
                else if (err.status === 403 && !/nao-autorizado/.test(window.location.href))
                    history.push('/nao-autorizado');
            }
            return inheritError ? throwError(err) : EMPTY;
        }),
    );
}

export function fetch(url, init) {
    const isRest = /restaurante/i.test(history.location.pathname);
    url = process.env['REACT_APP_API'] + (url ? url : '/');
    // console.log({
    //     ...init,
    //     headers: {
    //         Authorization: `JWT ${localStorage.getItem(isRest ? 'JWTR' : 'JWTANF')}`,
    //         ...(init?.headers || {}),
    //     },
    // });
    return nodeFetch(url, {
        ...init,
        headers: {
            Authorization: `JWT ${localStorage.getItem(isRest ? 'JWTR' : 'JWTANF')}`,
            ...(init?.headers || {}),
        },
    });
}
